import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Blog } from '../models/blog';

@Injectable({
  providedIn: 'root'
})

export class BlogService extends CrudService<Blog, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/blog`);

    this._http = _http;
  }

}

